export default __webpack_public_path__ + "exclamation-sign.png";